import React from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { StyleButtonWrapper,  ActionsContainer} from "./Styled";
import { TitleText, TitleWrapper } from "../../styled/TitleBar";
import LoadingButton from "../LoadingButton";

export interface TitleAction {
    title: string;
    onClick?: () => void;
    variant?: "contained" | "outlined";
    isLoading?: boolean;
}

interface TitleProps {
    title: string;
    actions: TitleAction[];
}

const TitleRow = ({ title, actions }: TitleProps) => {
    const [width] = useWindowSize();
    const isMobile = width < 768;

    return (
        <TitleWrapper>
            <TitleText> {title} </TitleText>
            <ActionsContainer isMobile={isMobile}>
                {actions.length > 0 && (
                    <StyleButtonWrapper>
                        {actions.map((action, index) => (
                            <LoadingButton
                                key={action.title}
                                text={action.title}
                                variant={action.variant}
                                onClick={action.onClick}
                                disabled={action.isLoading}
                                isLoading={action.isLoading}
                            />
                        ))}
                    </StyleButtonWrapper>
                )}
            </ActionsContainer>
        </TitleWrapper>
    );
};

export default TitleRow;